// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-layout {
	display: flex;
	flex-direction: column;
	padding-top: 72px; /* fixed header height */
	padding-left: 220px;
	height: 100%;
}

.main-layout-content {
	flex: 1 1;
	padding-left: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/index.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,iBAAiB,EAAE,wBAAwB;CAC3C,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,SAAO;CACP,kBAAkB;AACnB","sourcesContent":[".main-layout {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-top: 72px; /* fixed header height */\n\tpadding-left: 220px;\n\theight: 100%;\n}\n\n.main-layout-content {\n\tflex: 1;\n\tpadding-left: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
